/** How a mark opens the receipt behind its figure (rule 3: a shown number resolves to its receipt).
 *
 * The caller passes each datum's `receipt` (the address it routes to) and one `onOpenReceipt`
 * handler (it owns the router). A mark is a control **only when it has both**: a mark with nothing
 * behind it must not look or act like a link (design rule 6). `receiptProps` returns the props to
 * spread on the mark; they are empty when there is nothing to open.
 */

import type { KeyboardEvent } from "react";

/** Called with the datum's `receipt` and its key. */
export type OpenReceipt = (receipt: string, key: string) => void;

export function receiptProps(
  receipt: string | undefined,
  key: string,
  onOpenReceipt: OpenReceipt | undefined,
): {
  "data-receipt"?: string;
  onClick?: () => void;
  onKeyDown?: (event: KeyboardEvent) => void;
} {
  if (!receipt || !onOpenReceipt) return {};
  return {
    "data-receipt": receipt,
    onClick: () => {
      onOpenReceipt(receipt, key);
    },
    onKeyDown: (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onOpenReceipt(receipt, key);
      }
    },
  };
}

export function canOpen(receipt: string | undefined, onOpenReceipt: OpenReceipt | undefined): boolean {
  return Boolean(receipt && onOpenReceipt);
}
